<template>
    <vx-card class="toggle-container" title="Toggle Data" v-if="data !== null">
       <router-link :to="`/admin/toggle-data/`">Back</router-link>
      <vs-table stripe :data="data">
      <template slot="thead">
        <vs-th>
          Price
        </vs-th>
        <vs-th>
          LLV
        </vs-th>
        <vs-th>
          SCV
        </vs-th>
        <vs-th>
          Size
        </vs-th>
        <vs-th>
          Lot Size
        </vs-th>
        <vs-th>
          Rank
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td :data="data[indextr].price">
            {{data[indextr].price}}
          </vs-td>
          <vs-td :data="data[indextr].lot_location_value">
            {{data[indextr].lot_location_value}}
          </vs-td>
          <vs-td :data="data[indextr].scv">
            {{data[indextr].scv}}
          </vs-td>
          <vs-td :data="data[indextr].size">
            {{data[indextr].size}}
          </vs-td>
          <vs-td :data="data[indextr].lot_size">
            {{data[indextr].lot_size}}
          </vs-td>
          <vs-td :data="data[indextr].rank">
            {{data[indextr].rank}}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    </vx-card>
</template> 

<script>
import axios from 'axios'
import authHeader from '@/services/auth-header'

export default {
  name: 'ToggleDataEntry',
  data () {
    return {
      data: null
    }
  },
  computed: {
    active_user () { 
      return this.$store.state.active_user
    }
  },
  mounted () {
    this.zip = this.$route.params.zip
    this.get_data()
  },
  methods: {
    get_data () {
      axios.get(`${process.env.VUE_APP_API_HOST}admin/toggle_zip_data/${this.zip}`, authHeader()).then(response => {
        if (response.data.data) {
          this.data = response.data.data
        }
      })
        .catch(error => {
          this.$vs.notify({
            'time':10000,
            'title':'Error',
            'text':error.message,
            'color':'danger'
          })
          return false
        })
    }
  }
}
</script>
